export default "__VITE_ASSET__B05fD7lA__"